/* Waverles landing page: print tabs, "add the full match" to cart, sticky mobile CTA.
   Works on the live page and inside the theme editor. */

(function () {

  if (window.__wvlLanding) return;
  window.__wvlLanding = true;

  function selectTab(tablist, tab, focus) {
    var tabs = tablist.querySelectorAll('[role="tab"]');

    tabs.forEach(function (t) {
      var on = t === tab;

      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;

      var panel = document.getElementById(t.getAttribute('aria-controls'));

      if (panel) panel.hidden = !on;
    });

    if (focus) tab.focus();
  }

  function initTabs(scope) {
    (scope || document).querySelectorAll('[data-wvl-tabs]').forEach(function (tablist) {

      if (tablist.__wvlReady) return;

      tablist.__wvlReady = true;

      tablist.addEventListener('click', function (e) {
        var tab = e.target.closest('[role="tab"]');

        if (tab) selectTab(tablist, tab, false);
      });

      tablist.addEventListener('keydown', function (e) {
        var tabs = Array.prototype.slice.call(
          tablist.querySelectorAll('[role="tab"]')
        );

        var i = tabs.indexOf(document.activeElement);

        if (i < 0) return;

        var next = null;

        if (e.key === 'ArrowRight') {
          next = tabs[(i + 1) % tabs.length];
        }

        if (e.key === 'ArrowLeft') {
          next = tabs[(i - 1 + tabs.length) % tabs.length];
        }

        if (e.key === 'Home') {
          next = tabs[0];
        }

        if (e.key === 'End') {
          next = tabs[tabs.length - 1];
        }

        if (next) {
          e.preventDefault();
          selectTab(tablist, next, true);
        }
      });
    });
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  document.addEventListener('click', function (e) {

    var btn = e.target.closest('[data-wvl-add-all]');

    if (!btn) return;

    var panel = btn.closest('[data-wvl-panel]');

    if (!panel) return;

    var error = panel.querySelector('[data-wvl-error]');
    var items = [];
    var missing = null;

    panel.querySelectorAll('[data-wvl-line]').forEach(function (line) {

      var include = line.querySelector('[data-wvl-include]');

      if (include && !include.checked) return;

      var variant = line.querySelector('[data-wvl-variant]');

      if (!variant) return;

      if (!variant.value) {
        if (!missing) missing = variant;
        return;
      }

      items.push({
        id: Number(variant.value),
        quantity: 1
      });
    });

    if (error) error.textContent = '';

    if (missing) {

      if (error) {
        error.textContent = 'Choose a size for each piece first.';
      }

      missing.focus();

      return;
    }

    if (!items.length) {

      if (error) {
        error.textContent = 'Pick at least one piece.';
      }

      return;
    }

    var label = btn.textContent;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: items
      })
    }).then(function (r) {

      if (!r.ok) {
        return r.json().then(function (j) {
          throw new Error(
            j.description || 'Could not add to bag'
          );
        });
      }

      window.location.href =
        btn.getAttribute('data-cart-url') ||
        rootUrl() + 'cart';

    }).catch(function (err) {

      btn.disabled = false;
      btn.textContent = label;

      if (error) {
        error.textContent =
          err.message ||
          'Something went wrong. Please try again.';
      }
    });
  });

  function initSticky() {

    var bars = document.querySelectorAll('[data-wvl-sticky]');

    if (!bars.length) return;

    function update() {

      bars.forEach(function (bar) {

        var after =
          Number(bar.getAttribute('data-show-after')) || 600;

        bar.classList.toggle(
          'is-visible',
          window.scrollY > after
        );
      });
    }

    window.addEventListener('scroll', update, {
      passive: true
    });

    update();
  }

  /*
   * Restore page scrolling after Shopify cart drawer closes.
   * This prevents the Waverles landing page from remaining locked
   * after the drawer has been opened and closed.
   */
  function initCartDrawerScrollFix() {

    if (window.__wvlCartDrawerScrollFix) return;

    window.__wvlCartDrawerScrollFix = true;

    var lockedScrollY = 0;

    function saveScrollPosition() {
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
    }

    function restoreScroll() {

      var html = document.documentElement;
      var body = document.body;

      if (!html || !body) return;

      /*
       * Remove common Shopify/theme scroll-lock classes.
       */
      html.classList.remove('overflow-hidden');
      body.classList.remove('overflow-hidden');
      body.classList.remove('js-drawer-open');
      body.classList.remove('drawer-open');
      body.classList.remove('overflow-hidden-tablet');

      /*
       * Restore inline scroll styles if the drawer added them.
       */
      if (html.style.overflow === 'hidden') {
        html.style.overflow = '';
      }

      if (body.style.overflow === 'hidden') {
        body.style.overflow = '';
      }

      if (body.style.position === 'fixed') {
        body.style.position = '';
        body.style.top = '';
        body.style.left = '';
        body.style.right = '';
        body.style.width = '';
      }

      if (body.style.height === '100vh') {
        body.style.height = '';
      }

      if (body.style.touchAction === 'none') {
        body.style.touchAction = '';
      }

      /*
       * Make sure the page can scroll again.
       */
      html.style.removeProperty('overflow');
      body.style.removeProperty('overflow');

      /*
       * If the drawer temporarily fixed the body,
       * restore the previous scroll position.
       */
      if (lockedScrollY > 0) {
        window.scrollTo({
          top: lockedScrollY,
          left: 0,
          behavior: 'auto'
        });
      }
    }

    function drawerIsOpen(drawer) {

      if (!drawer) return false;

      return (
        drawer.classList.contains('active') ||
        drawer.classList.contains('animate') ||
        drawer.hasAttribute('open') ||
        drawer.getAttribute('aria-hidden') === 'false'
      );
    }

    function checkDrawerState() {

      var drawer =
        document.querySelector('cart-drawer') ||
        document.querySelector('.cart-drawer');

      if (!drawer) return;

      var isOpen = drawerIsOpen(drawer);

      if (isOpen) {
        saveScrollPosition();
      } else {
        setTimeout(restoreScroll, 50);
        setTimeout(restoreScroll, 150);
        setTimeout(restoreScroll, 300);
      }
    }

    /*
     * Catch cart drawer close button.
     */
    document.addEventListener('click', function (e) {

      var closeButton = e.target.closest(
        'cart-drawer .drawer__close,' +
        'cart-drawer [aria-label*="Close"],' +
        'cart-drawer button[name="close"],' +
        '.cart-drawer__close,' +
        '.drawer__close'
      );

      if (!closeButton) return;

      setTimeout(restoreScroll, 50);
      setTimeout(restoreScroll, 150);
      setTimeout(restoreScroll, 300);
      setTimeout(restoreScroll, 500);
    });

    /*
     * Catch Escape key used to close the drawer.
     */
    document.addEventListener('keydown', function (e) {

      if (e.key !== 'Escape') return;

      setTimeout(restoreScroll, 50);
      setTimeout(restoreScroll, 150);
      setTimeout(restoreScroll, 300);
      setTimeout(restoreScroll, 500);
    });

    /*
     * Watch cart drawer class/attribute changes.
     * Shopify changes these when the drawer opens/closes.
     */
    var observer = new MutationObserver(function () {
      checkDrawerState();
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: [
        'class',
        'style',
        'open',
        'aria-hidden'
      ],
      subtree: true
    });

    /*
     * Also watch the body because Shopify themes commonly
     * apply the scroll lock directly to body/html.
     */
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: [
        'class',
        'style'
      ]
    });
  }

  function init(scope) {
    initTabs(scope);
  }

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', function () {
      init();
      initSticky();
      initCartDrawerScrollFix();
    });

  } else {

    init();
    initSticky();
    initCartDrawerScrollFix();
  }

  /*
   * Theme editor support.
   */
  document.addEventListener(
    'shopify:section:load',
    function (e) {
      init(e.target);
      initSticky();
      initCartDrawerScrollFix();
    }
  );

  document.addEventListener(
    'shopify:block:select',
    function (e) {

      var panelId =
        'wvl-panel-' + e.detail.blockId;

      var tab = document.querySelector(
        '[role="tab"][aria-controls="' +
        panelId +
        '"]'
      );

      if (tab) {
        selectTab(
          tab.closest('[data-wvl-tabs]'),
          tab,
          false
        );
      }
    }
  );

})();